import React from 'react';
import ModalWindow from 'BVComponents/modal_window';
import { t } from 'bv-i18n';

export default (tKey, modalProps = {}) => (WrappedComponent) => (props) => (
  <ModalWindow title={t(tKey)} {...modalProps}>
    <WrappedComponent {...props} />
  </ModalWindow>
);
